import { Section } from 'components/common/override-rates/Section';
import ProductLineTitleV2 from 'components/common/general/ProductLineTitleV2';
import styled from 'styled-components';
import ProductSummary from 'components/common/uw-review/ProductSummary';
import { colors } from '@insurancemenu/imenu-components-lib';

export const SectionStyled = styled(Section)`
  margin-bottom: 5rem;
`;

export const ProductLineTitleV2Styled = styled(ProductLineTitleV2)`
  padding: 3rem 0;
`;

export const ProductListStyled = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(35rem, 1fr));
  gap: 2rem;
  list-style: none;
  padding: 0;
  margin: 0 0 2rem;
`;

export const ProductItemStyled = styled.li`
  border: 0.1rem solid ${colors.neutral[400]};
  padding: 2.5rem 3rem;
  border-radius: 10px;
  min-width: 42rem;
`;

export const ProductSummaryStyled = styled(ProductSummary)`
  border: none;
  padding: 0;
  width: 100%;
`;

export const ProductNameStyled = styled.h4`
  font-size: 1.8rem;
  line-height: 2.4rem;
  font-weight: 700;
  padding: 0;
  margin: 0 0 3rem;
`;
